import useMount from '@src/utils/hooks/use-mount';
import { computed, observable } from 'mobx';
import { useEffect } from 'react';
class MechaMainStore {


  @observable isModalOpen = false;
  // @observable setIsModalOpen = false;



  @observable isActive = false;
  // 机甲hover状态
  @observable mechaHoverState = false;
  // 机甲主store
  @observable mechaStore;
  // 机甲类型切换状态, 切换中无法进行二次切换;
  @observable mechaTypeChangeState = false;
  // 机甲的当前展示类型: 1: 人型状态; 2: 其他形态; 默认1
  @observable mechaCurrentType = 1;
  constructor(options = {}) {
    Object.assign(this, options);
  }

  // // 机甲是否有其他可切换状态
  // @computed
  // get hasOtherType() {
  //   return this.mechaStore.currentMechaMsg?.main.mecha_image_other_type;
  // }

  /**
   * 点击切换机甲的展示类型
   * @param mechaId
   * @returns {boolean}
   */
  onClickChangeMechaType = () => {
    if (this.mechaTypeChangeState) {
      return false;
    }
    this.mechaTypeChangeState = true;
    this.mechaCurrentType = this.mechaCurrentType === 1 ? 2 : 1;
    clearTimeout(this.changeMechaTypeTimer);
    this.changeMechaTypeTimer = setTimeout(() => {
      this.mechaTypeChangeState = false;
      clearTimeout(this.changeMechaTypeTimer);
    }, 500);
  };
  /**
   * 初始化动画播放
   */
  initAnimation = () => {
    clearTimeout(this.animationTimer);
    this.animationTimer = setTimeout(() => {
      this.isActive = true;
    }, 500);
  };



  use() {


    useEffect(
      () => {
        if (!this.isActive) {
          this.initAnimation();
        }
      },
      [this.isActive]
    );



    useMount(() => {

    });
  }
}

export default MechaMainStore;
